import { useOpenLifecycleFromProductId } from 'components/secondaryMarket/productSearch/utils';
import { useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

import type { ButtonsPanelProps } from './ButtonPanel.connect';
import { OpenInLifecycleButton } from './OpenInLifecycleButton';
import { QuoteButton } from './QuoteButton';

export function ButtonsPanel({
  rowId,
  isCpOrderEntitled,
  isCpOrderEnabled,
  isLiveQuoteEntitled,
  isLiveQuoteEnabled,
  isRealtimeQuoteEnabled,
  isLimitOrderEntitled,
  isLimitOrderEnabled,
  openLiveTab,
  openQuote,
  openCPOrderTab,
  openLimitOrderTab,
}: ButtonsPanelProps) {
  const onOpenQuote = useCallback(() => {
    logAnalytics.trackEvent('Secondary market', 'Open RT quote form');
    openQuote(rowId);
  }, [openQuote, rowId]);

  const onOpenCPOrderTab = useCallback(() => {
    logAnalytics.trackEvent('Secondary market', 'Open CP Order form');
    openCPOrderTab(rowId!);
  }, [rowId, openCPOrderTab]);

  const onOpenRealTimeScreen = useCallback(() => {
    logAnalytics.trackEvent('Secondary market', 'Open Live trade');
    openLiveTab(rowId!);
  }, [rowId, openLiveTab]);
  const onOpenLimitOrderScreen = useCallback(() => {
    logAnalytics.trackEvent('Secondary market', 'Open Limit Order screen');
    openLimitOrderTab(rowId!);
  }, [rowId, openLimitOrderTab]);

  const openLifecycleFromProductId = useOpenLifecycleFromProductId();

  return (
    <div className="d-flex flex-column align-items-stretch w-100 mx-0">
      <QuoteButton
        className="mb-2"
        labelKey="secondaryMarket.tabType.realtimeQuote"
        onClick={onOpenQuote}
        disabled={!isRealtimeQuoteEnabled}
        e2e="quote-screen-open-btn"
      />
      {isCpOrderEntitled && (
        <QuoteButton
          className="mb-2"
          labelKey="secondaryMarket.tabType.closePriceOrder"
          onClick={onOpenCPOrderTab}
          disabled={!isCpOrderEnabled}
          e2e="cp-order-screen-open-btn"
        />
      )}
      {isLiveQuoteEntitled && (
        <QuoteButton
          className="mb-2"
          labelKey="secondaryMarket.tabType.live"
          onClick={onOpenRealTimeScreen}
          disabled={!isLiveQuoteEnabled}
          e2e="real-time-screen-open-btn"
        />
      )}
      {isLimitOrderEntitled && (
        <QuoteButton
          className="mb-2"
          labelKey="secondaryMarket.tabType.limitOrder"
          onClick={onOpenLimitOrderScreen}
          disabled={!isLimitOrderEnabled}
          e2e="limit-order-screen-open-btn"
        />
      )}
      {rowId !== null && (
        <OpenInLifecycleButton
          className="mb-2"
          labelKey="secondaryMarket.modal.buttonOpenInLifecycle"
          onClick={() => openLifecycleFromProductId(rowId)}
        />
      )}
    </div>
  );
}
